import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import Headersecondpage from "./headersecondpage";
import "./SinglePageLayout.css";

const SinglePageLayout: React.FC = () => {
  return (
    <>
      {/* Header */}
      <Headersecondpage />

      {/* Terms & Privacy Section */}
      <div className="container my-5 terms-container">
        <h2 className="text-center fw-bold mb-3 title-text">
          Terms & Conditions & Privacy Policy
        </h2>
        <h5 className="text-center mb-5 subtitle-text">
          {/* For <strong>Color Crush</strong> and <strong>Xyloite Technology</strong> */}
        </h5>

        <p>
          Welcome to <strong>Xyloite Technology</strong>. By accessing our website{" "}
          <a
            href="https://www.xyloite.com"
            target="_blank"
            rel="noopener noreferrer"
            className="link-bold"
          >
            www.xyloite.com
          </a>{" "}
          or using our mobile application <strong>Color Crush</strong> (“App”), you
          agree to the following Terms & Conditions and Privacy Policy. Please read
          them carefully before using our services.
        </p>

        <h4>Acceptance of Terms</h4>
        <p>
          By using our website or app, you confirm that you accept these Terms. If
          you do not agree, please discontinue use of our services immediately.
        </p>

        <h4>Changes to Terms</h4>
        <p>
          We may update these Terms at any time. Changes will be posted on this page.
          Continued use after updates means you accept the revised Terms.
        </p>

        <h4>Services Provided</h4>
        <p>
          <strong>Xyloite Technology</strong> offers:
        </p>
        <ul>
          <li>IT consulting</li>
          <li>Software development</li>
          <li>Technical support</li>
          <li>AI-powered solutions for legacy and SaaS platforms</li>
        </ul>
        <p>
          Our mobile app <strong>Color Crush</strong> is part of our product
          portfolio. For more details, visit our{" "}
          <a
            href="https://www.xyloite.com/services"
            target="_blank"
            rel="noopener noreferrer"
            className="link-bold"
          >
            Services page
          </a>
          .
        </p>

        <h4>Account Registration</h4>
        <p>Some features may require account creation. You agree to:</p>
        <ul>
          <li>Provide accurate and complete information</li>
          <li>Keep your credentials secure</li>
          <li>Update your details as needed</li>
          <li>Accept responsibility for all activity under your account</li>
        </ul>
        <p>
          We reserve the right to suspend or terminate accounts that violate these
          Terms.
        </p>

        <h4>Prohibited Activities</h4>
        <p>You may not:</p>
        <ul>
          <li>Use our services for illegal or unauthorized purposes</li>
          <li>Attempt unauthorized access to our systems or data</li>
          <li>Interfere with or disrupt our servers or infrastructure</li>
          <li>Upload malicious code or content</li>
          <li>Harm our reputation or user experience</li>
        </ul>
        <p>
          Violations may result in suspension, legal action, or reporting to
          authorities.
        </p>

        <h4>Data Security and Breach</h4>
        <p>
          We implement reasonable security measures to protect user data. In case of
          a data breach, we will investigate, mitigate, and notify affected users as
          required by law.
        </p>

        <h4>Privacy Policy for Color Crush</h4>

        <h5>7.1. What We Do Not Collect</h5>
        <p>We do not collect, store, or share personally identifiable information such as:</p>
        <ul>
          <li>Your name</li>
          <li>Email address</li>
          <li>Phone number</li>
          <li>Precise location</li>
        </ul>

        <h5>7.2. Data Collected by Third Parties</h5>
        <p>
          While using Color Crush, third-party services may collect limited data
          automatically to enable core features and serve ads.
        </p>

        <h6>a. Google Play Games Services</h6>
        <p>Used for:</p>
        <ul>
          <li>Player authentication</li>
          <li>Leaderboards and achievements</li>
        </ul>
        <p>
          Google may collect user and device data. For more information, visit:{" "}
          <a
            href="https://policies.google.com/privacy"
            target="_blank"
            rel="noopener noreferrer"
            className="link-bold"
          >
            🔗 Google Play Games Services Privacy Policy
          </a>
        </p>

        <h6>b. Advertising (AdMob & Mediation Partners)</h6>
        <p>
          We use AdMob by Google and its mediation partners to serve ads. These may
          collect:
        </p>
        <ul>
          <li>Device identifiers</li>
          <li>IP address</li>
          <li>Approximate location</li>
          <li>Ad interaction data</li>
        </ul>
        <p>
          This information helps deliver and improve ads. You can opt out of
          personalized ads via device settings or through the{" "}
          <a
            href="https://optout.networkadvertising.org/"
            target="_blank"
            rel="noopener noreferrer"
            className="link-bold"
          >
            Network Advertising Initiative Opt-Out Page
          </a>
          .
        </p>

        <p>Third-party ad networks we work with include:</p>
        <ul>
          <li>AdMob</li>
          <li>Meta Audience Network</li>
          <li>Unity Ads</li>
          <li>IronSource Ads</li>
        </ul>

        <p>Each has its own privacy practices:</p>
        <ul>
          <li>
            <a
              href="https://policies.google.com/privacy"
              target="_blank"
              rel="noopener noreferrer"
              className="link-bold"
            >
              🔗 Google Privacy Policy
            </a>
          </li>
          <li>
            <a
              href="https://support.google.com/admob/answer/6128543?hl=en"
              target="_blank"
              rel="noopener noreferrer"
              className="link-bold"
            >
              🔗 AdMob Privacy Policy
            </a>
          </li>
          <li>
            <a
              href="https://www.facebook.com/privacy/policy/"
              target="_blank"
              rel="noopener noreferrer"
              className="link-bold"
            >
              🔗 Meta Audience Network Privacy Policy
            </a>
          </li>
          <li>
            <a
              href="https://unity.com/legal/privacy-policy"
              target="_blank"
              rel="noopener noreferrer"
              className="link-bold"
            >
              🔗 Unity Ads Privacy Policy
            </a>
          </li>
          <li>
            <a
              href="https://developers.is.com/ironsource-mobile/ironsource-mobile-privacy-policy/"
              target="_blank"
              rel="noopener noreferrer"
              className="link-bold"
            >
              🔗 IronSource Privacy Policy
            </a>
          </li>
        </ul>

        <h5>7.3. Data Security</h5>
        <p>
          We do not store or manage any user data on our servers. Third-party
          providers are responsible for managing their own data security standards.
        </p>

        <h5>7.4. Children’s Privacy</h5>
        <p>
          Color Crush is suitable for general audiences. We do not knowingly collect
          data from children under the age of 13. If you believe a child has
          submitted personal information to a third-party network through our app,
          please contact us for assistance.
        </p>

        <h4>Governing Law</h4>
        <p>
          These Terms are governed by the laws of <strong>Tamil Nadu, India</strong>.
          Any disputes shall be subject to the jurisdiction of the courts in{" "}
          <strong>Coimbatore, Tamil Nadu</strong>.
        </p>

        {/* <h4>Contact Information</h4>
        <p>
          If you have any questions about these Terms or our data practices, please
          contact us at:
        </p>
        <p>
          📧 <strong>Email:</strong>{" "}
          <a href="mailto:support@xyloite.com" className="link-bold">
            support@xyloite.com
          </a>
          <br />
          🌐 <strong>Website:</strong>{" "}
          <a
            href="https://www.xyloite.com"
            target="_blank"
            rel="noopener noreferrer"
            className="link-bold"
          >
            www.xyloite.com
          </a>
        </p> */}
      </div>
    </>
  );
};

export default SinglePageLayout;
